export const cuisineStyles = [
    "haute_cuisine",
    "creative_cuisine",
    "traditional_cuisine",
    "avant_garde_cuisine"
  ];  